export const getVideoDuration = async (file: File): Promise<number | undefined> => {
  if (!file.type.startsWith('video/')) {
    return undefined
  }

  return new Promise(resolve => {
    const url = URL.createObjectURL(file)
    const video = document.createElement('video')

    const cleanup = (value: number | undefined) => {
      URL.revokeObjectURL(url)
      resolve(value)
    }

    video.preload = 'metadata'
    video.addEventListener('loadedmetadata', () => {
      const duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : undefined
      cleanup(duration)
    })
    video.addEventListener('error', () => cleanup(undefined))

    video.src = url
    video.load()
  })
}
